<template>
    <vPerformanceProductLineComponent :postList="postList" v-if="flag"></vPerformanceProductLineComponent>
</template>
<script>
import vPerformanceProductLineComponent from '../../listComponent/basicdata/performance/performanceProductLineComponent.vue';
export default {
    name: 'performance_product',
    components: {
        vPerformanceProductLineComponent
    },
    data() {
        return {
            postList: {
                headerTitle: false,
                searchBtn: true,
                resetBtn: true,
                downFileBtn: true,
                setBtn: true
            },
            flag: false
        };
    },
    mounted() {
        this.flag = false;
        this.$nextTick(() => {
            this.flag = true;
        });
    },
    methods: {}
};
</script>
<style lang="scss" scoped="scoped">
</style>